"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var camelizeKeys_1 = require("./camelizeKeys");

var UploadcareFile =
/** @class */
function () {
  function UploadcareFile(fileInfo, _a) {
    var baseCDN = _a.baseCDN,
        defaultEffects = _a.defaultEffects,
        fileName = _a.fileName;
    this.name = null;
    this.size = null;
    this.isStored = null;
    this.isImage = null;
    this.cdnUrl = null;
    this.cdnUrlModifiers = null;
    this.originalUrl = null;
    this.originalFilename = null;
    this.imageInfo = null;
    this.videoInfo = null;
    var uuid = fileInfo.uuid,
        s3Bucket = fileInfo.s3Bucket;
    var urlBase = s3Bucket ? "https://" + s3Bucket + ".s3.amazonaws.com/" + uuid + "/" + fileInfo.filename : baseCDN + "/" + uuid + "/";
    var cdnUrlModifiers = defaultEffects ? "-/" + defaultEffects : null;
    var cdnUrl = "" + urlBase + (cdnUrlModifiers || '');
    var originalUrl = uuid ? urlBase : null;
    this.uuid = uuid;
    this.name = fileName || fileInfo.filename;
    this.size = fileInfo.size;
    this.isStored = fileInfo.isStored;
    this.isImage = fileInfo.isImage;
    this.cdnUrl = cdnUrl;
    this.cdnUrlModifiers = cdnUrlModifiers;
    this.originalUrl = originalUrl;
    this.originalFilename = fileInfo.originalFilename;
    this.imageInfo = camelizeKeys_1.default(fileInfo.imageInfo);
    this.videoInfo = camelizeKeys_1.default(fileInfo.videoInfo);
  }

  return UploadcareFile;
}();

exports.UploadcareFile = UploadcareFile;